export default __webpack_public_path__ + "static/media/Contact Page Image 1.cd4c556a.png";